/**
 * WISHLIST PRODUCT MOVE
 * 
 * module de gestion de déplacement/copy
 * de produit dans la wishlist
 * via une popin dans
 * la partie PRO de l'espace mon compte
 */
import $ from "jquery";
import { dialog } from "../../../../components/dialog.js";
const utils = require('../utils.js').default;

const WLProductMove = (() => {
    const DOM_MOVE_PRODUCT_IN_WISHLIST ='.js-wishlists-list-product-move';
    const POPIN_MOVE_PRODUCT_IN_WISHLIST = 'popin-move-product-in-wishlist';
    const DOM_POPIN_MOVE_PRODUCT_IN_WISHLIST = `[data-js-dialog-id="${POPIN_MOVE_PRODUCT_IN_WISHLIST}"]`;
    const DOM_BTN_POPIN_MOVE_PRODUCT_IN_WISHLIST_OPEN = `[data-js-dialog-open="${POPIN_MOVE_PRODUCT_IN_WISHLIST}"]`;
    const ERROR_FEATURE_FORBIDDEN = 'Vous devez être professionnels et connecté à votre espace, pour utiliser cette fonctionnalité.';

    /**
     * PRODUCT MOVE
     * 
     * déplacement d'un produit dans une wishlist.
     * Si déplacement, on supprime le produit de la WL source
     * @param {event} event 
     */
    const ProductMove = (event) => {
        event.preventDefault();
        // récupération des données
        let type = $(event.currentTarget).attr('data-type');
        let listeId = $(event.currentTarget).attr('data-list-id');
        let ean = parseInt($(event.currentTarget).attr('data-product-id'));
        let price = parseFloat($(event.currentTarget).attr('data-product-price'));
        tracking(ean, listeId, type);
        utils.debug('WL PRODUCT MOVE', {type, listeId, ean}); 
        window.WL.addToWishlist([ean], listeId);
        if (type === 'move_to_wishlist') {
            window.WL.removeFromWishlist(ean).then(() => {
                utils.dispatchCustomEvent('ANIMATION_PRODUCT_REMOVE', {id:ean});
            });
        }
        dialog.close();
    };
    /**
     * PRODUCT MOVE EVENTS
     * 
     * bind des events
     */
    const ProductMoveEvents = () => {
        $(`${DOM_MOVE_PRODUCT_IN_WISHLIST} button`).off().on('click', ProductMove);
    };
    /**
     * PRODUCT MOVE IN WISHLIST UPDATES
     * 
     * listener pour le rafraichissement des lists/produits
     */
    const ProductMoveInWishlistUpdates = () => {
        document.addEventListener('MOVE_PRODUCT_IN_WISHLIST_UPDATES', (event) => {
            const listType = event.detail !== null && event.detail.type !== undefined && event.detail.type === 'all' ? 'all' : '';
            updateLists(listType);
            ProductMoveEvents();
        });
    };
    /**
     * POPIN OPEN (func)
     * 
     * Ouverture de la popin creation d'adresse
     * @param {event} event 
     */
    const popinOpen = (event) => {
        event.preventDefault();
        if (!(utils.getContext() === 'pro' && utils.userLogged())) {
            setTimeout(() => {
                utils.dispatchCustomEvent('TEMPLATE_ERROR', {error:ERROR_FEATURE_FORBIDDEN});
            }, 50);
            return;
        }
        updateTemplate(event);
        updateLists();
        ProductMoveEvents();
    };
    /**
     * TRACKING
     * @param {number} ean
     * @param {string} listeId
     * @param {string} type
     */
    const tracking = (ean, listeId, type) => {
        // tracker
        let product = window.WL.getProductData(ean);
        if (!product) return;
        let productLabel = product.name;
        let productCategory = product.category;
        let flattenProduct = window.WL.getWishlistFlattenProduct(
            product.ean,
            product.name,
            product.category ,
            product.price,
            product.quantity
        );
        utils.dispatchCustomEvent('TRACKERS_WISHLIST_PRODUCT_MOVE', {productLabel, productCategory});
        utils.dispatchCustomEvent('TRACKER_WISHLIST_PRODUCTS_ADD_TO_CART', {
            listLabel: listeId,
            listCategory: utils.getContext(),
            products: [flattenProduct]
        });
        if (type === 'move_to_wishlist') {
            utils.dispatchCustomEvent('TRACKER_WISHLIST_PRODUCTS_REMOVE_FROM_CART', {
                listLabel: window.WL.getCurrentWishlist(),
                listCategory: utils.getContext(),
                products: [flattenProduct]
            });
        }
    };
    /**
     * UPDATE LISTS
     * 
     * generation des lists via templates
     * @param {string} listeLoaded 
     */
    const updateLists = (listeLoaded) => {
        $(`${DOM_MOVE_PRODUCT_IN_WISHLIST}`).empty();
        let wishlists = listeLoaded === 'all' ? 
            window.WL.getWishListsWithCurrent() :
            window.WL.getWishListsButCurrent();
        wishlists.forEach((list) => {
            utils.dispatchCustomEvent('TEMPLATE_COMMON_PART', {
                append: true,
                templateId: 'tpl-move-product-in-wishlist',
                targetElement: `${DOM_MOVE_PRODUCT_IN_WISHLIST}`,
                data: {
                    listSlug: list.slug,
                    listName: list.name,
                    listQuantity: list.quantity.toString(),
                    eventType: $(`${DOM_MOVE_PRODUCT_IN_WISHLIST}`).attr('data-type'),
                    ean :$(`${DOM_MOVE_PRODUCT_IN_WISHLIST}`).attr('data-product-id'),
                    name :$(`${DOM_MOVE_PRODUCT_IN_WISHLIST}`).attr('data-product-name'),
                    cat :$(`${DOM_MOVE_PRODUCT_IN_WISHLIST}`).attr('data-product-cat'),
                    price :$(`${DOM_MOVE_PRODUCT_IN_WISHLIST}`).attr('data-product-price'),
                }
            });
        });

        if ($(DOM_MOVE_PRODUCT_IN_WISHLIST).attr('data-type') === 'add_to_wishlist') {
            $(`${DOM_MOVE_PRODUCT_IN_WISHLIST} .js-icon-add`).removeClass('u-hidden');
            $(`${DOM_MOVE_PRODUCT_IN_WISHLIST} .js-icon-move`).addClass('u-hidden');
        } else {
            $(`${DOM_MOVE_PRODUCT_IN_WISHLIST} .js-icon-add`).addClass('u-hidden');
            $(`${DOM_MOVE_PRODUCT_IN_WISHLIST} .js-icon-move`).removeClass('u-hidden');
        }
        utils.dispatchCustomEvent('MOVE_PRODUCT_IN_WISHLIST_UPDATED');
    };
    /**
     * UPDATE TEMPLATE (func)
     * 
     * Mise à jour du template de la popin 
     * de suppression d'adresse
     * @param {event} event 
     */
    const updateTemplate = (event) => {
        $(`${DOM_POPIN_MOVE_PRODUCT_IN_WISHLIST} .c-dialog__title`).text($(event.currentTarget).attr('aria-label'));
        $(`${DOM_MOVE_PRODUCT_IN_WISHLIST}`)
            .attr('data-type', $(event.currentTarget).attr('data-type'))
            .attr('data-product-id', $(event.currentTarget).attr('data-product-id'))
            .attr('data-product-name', $(event.currentTarget).attr('data-product-name'))
            .attr('data-product-cat', $(event.currentTarget).attr('data-product-cat'))
            .attr('data-product-price' , $(event.currentTarget).attr('data-product-price'));
            
    };
    /**
     * INIT (func)
     */
    const init = () => {
        utils.debug('WL PRODUCT MOVE', 'initialisation'); 
        // déplacement/copie d'un produit dans une autre liste (si pro/connecté)
        $(DOM_BTN_POPIN_MOVE_PRODUCT_IN_WISHLIST_OPEN).off().on('click', popinOpen);
        ProductMoveInWishlistUpdates();
        document.addEventListener('WISHLIST_PRODUCT_MOVE_POPIN_OPEN', (event) => {
            updateLists('all');
            ProductMoveEvents()
        });
    }
    return {init}
})();
export default WLProductMove;